import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "services/client";

export const withQuery = (Component) => (props) =>
  (
    <QueryClientProvider client={queryClient}>
      <Component {...props} />
    </QueryClientProvider>
  );
